import React, { useEffect, useState } from 'react';
import { Route } from 'react-router';
import { List, ListItem, TextField, Paper, Grid, ListItemText, ListItemIcon, Typography, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import LinkIcon from '@mui/icons-material/Link';
import Error from '@mui/icons-material/Error';

import ZkiliAppApi from '../../API/ZkiliAppApi';
import copyToClipboard from '../../Functions/CopyTextToClipBoard';

import useSnackbar from '../../Hooks/useSnackbar';
import useInterval from '../../Hooks/useInterval';

import Page from '../../Components/Page';
import SEO from '../../Components/SEO';
import ZkillCustom from './ZkillCustom';
import ZkillCustomList from './ZkillCustomList';
import { Switch } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        padding: theme.spacing(1)
    },
    input: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        width: '100%'
    },
    errorPaper: {
        padding: theme.spacing(1),
        textAlign: 'center'
    },
    statItem: {
        textAlign: 'center',
        padding: '8px 16px'
    },
    historyDescriptionDiv: {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(2)
    },
    statPaper: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    }
}));

const ZkiliLinks = () => {
    const classes = useStyles();
    const [url, setUrl] = useState('');
    const [error, setError] = useState('');
    const [zkiliStats, setZkiliStats] = useState({
        history: [],
        counterData: { created: 0, elminered: 0 }
    });
    const { openSnackbar } = useSnackbar();

    const onChange = e => setUrl(e.target.value);

    const fixedUrlZkili = url.replace('zkillboard', 'zkilIboard');
    const fixedUrlZkilll = url.replace('zkillboard', 'zkilllboard');

    const copyText = text => {
        copyToClipboard(text);
        openSnackbar(`Copied ${text} to your clipboard`);
    };
    const loadZkiliStats = () => {
        ZkiliAppApi.zkiliRedirectStats()
            .then(data => {
                setZkiliStats(data);
                setError('');
            })
            .catch(() => {
                setError('Failed to load Zkili redirect stats');
            });
    };

    useInterval(30000, loadZkiliStats);
    useEffect(() => {
        loadZkiliStats();
    }, []);

    const ZkillLinks = () => (
        <Grid container justifyContent="center">
            {error && (
                <Grid item xs={12} md={10} lg={8}>
                    <Paper className={classes.errorPaper}>
                        <Typography>Failed to load the Zkili redirect statistics</Typography>
                        <Error color="secondary" />
                    </Paper>
                </Grid>
            )}

            <Grid item xs={12} md={8} lg={7} xl={6}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={6} className={classes.statItem}>
                        <Paper className={classes.statPaper}>
                            <Typography variant="h4">{zkiliStats.counterData.elminered.toLocaleString()}</Typography>
                            <Typography variant="h5">Users redirected</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.statItem}>
                        <Paper className={classes.statPaper}>
                            <Typography variant="h4">{zkiliStats.counterData.created.toLocaleString()}</Typography>
                            <Typography variant="h5">Links spoofed</Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} md={8} lg={7} xl={6}>
                <div>
                    <p>This site helps you link to the only player who matters, El'Miner</p>
                    <p>
                        Change any zki<b>ll</b>board.com link to zki<b>li</b>board.com or zki<b>lll</b>board.com
                    </p>
                    <p>
                        Hatemail can be sent to <a href="https://zkiliboard.com/character/2115333675/">Mc Crecket</a>
                    </p>
                </div>

                <TextField
                    className={classes.input}
                    value={url}
                    onChange={onChange}
                    label="Link fixer"
                    placeholder="Enter zkillboard.com links in here to fix them automatically"
                />
                {url !== fixedUrlZkili && (
                    <Paper>
                        <List>
                            <ListItem button onClick={() => copyText(fixedUrlZkili)}>
                                <ListItemIcon>
                                    <LinkIcon />
                                </ListItemIcon>
                                <ListItemText primary={fixedUrlZkili} secondary="zkiliboard - link with li" />
                            </ListItem>
                            <ListItem button onClick={() => copyText(fixedUrlZkilll)}>
                                <ListItemIcon>
                                    <LinkIcon />
                                </ListItemIcon>
                                <ListItemText primary={fixedUrlZkilll} secondary="zkilllboard - link with lll" />
                            </ListItem>
                        </List>
                    </Paper>
                )}
            </Grid>
        </Grid>
    );

    const ZkiliHistory = () => (
        <Grid container justifyContent="center">
            <SEO
                title="Zkili Link History"
                path="/zkili-links/history"
                description="Previously clicked el'miner links"
            />

            <Grid item>
                {zkiliStats.history.length > 0 && (
                    <TableContainer component={Paper}>
                        <div className={classes.historyDescriptionDiv}>
                            <Typography variant="h6">Zkili History</Typography>
                            <Typography>Sorted by most recently clicked</Typography>
                        </div>
                        <Table size="small" aria-label="History of clicked zkili links">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Clicks</TableCell>
                                    <TableCell>Shown Link</TableCell>
                                    <TableCell>Real link</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {zkiliStats.history.map((item, key) => {
                                    const secondaryUrl = item.targetUrl;

                                    return (
                                        <TableRow key={key}>
                                            <TableCell>{item.counter}</TableCell>
                                            <TableCell>
                                                <a href={item.url}>{item.url}</a>
                                            </TableCell>
                                            <TableCell>
                                                <a href={secondaryUrl}>{secondaryUrl}</a>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>
        </Grid>
    );

    return (
        <Page
            title="Zkiliboard Links"
            tabs={[
                { to: '/zkili-links/links', label: 'Links' },
                { to: '/zkili-links/custom', label: 'Custom' },
                { to: '/zkili-links/history', label: 'History' }
            ]}
        >
            <SEO title="Zkili Links" path="/zkili-links" description="The zkili redirect dashboard" />

            <Switch>
                <Route exact path="/zkili-links" component={ZkillLinks} />
                <Route exact path="/zkili-links/links" component={ZkillLinks} />
                <Route exact path="/zkili-links/history" component={ZkiliHistory} />
                <Route exact path="/zkili-links/custom" component={ZkillCustomList} />
                <Route exact path="/zkili-links/custom/create" component={ZkillCustom} />
                <Route exact path="/zkili-links/custom/:id" component={ZkillCustom} />
            </Switch>
        </Page>
    );
};

export default ZkiliLinks;
